import React from 'react'
import ReactDOM from 'react-dom'
import { Store } from '../Store'
import { useHotkeys } from 'react-hotkeys-hook'

const AppMenu = React.lazy(() => import('../AppMenu'))

type Props = {
    toggleSidebar?: () => void,
    compressed: boolean
}

function Sidebar ({ toggleSidebar = () => {}, compressed }: Props) {
    const { state } = React.useContext(Store)

    useHotkeys('meta+ctrl+s', () => {
        toggleSidebar()
    }, [toggleSidebar])

    React.useEffect(() => {
        const sidebar = document.getElementsByClassName('js-sidebar')?.[0]

        if (sidebar && state.fullScreen) {
            sidebar.classList.add('__is-fullscreen')
        } else {
            sidebar.classList.remove('__is-fullscreen')
        }
    }, [state.fullScreen])

    React.useEffect(() => {
        if (state.sidebar) {
            document.getElementsByClassName('js-sidebar')[0].classList.add('__has-sidebar')
        } else {
            document.getElementsByClassName('js-sidebar')[0].classList.remove('__has-sidebar')
        }
    }, [state.sidebar])

    return state.sidebar && (
        <>
            {ReactDOM.createPortal(
                <React.Suspense fallback="Loading...">
                    <AppMenu compressed={compressed} menus={state.campaignMenu!}/>
                </React.Suspense>,
                document.getElementsByClassName('js-sidebar')[0]
            )}
        </>
    )
}

export default Sidebar
